var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.wrapperClasses },
    [
      _c(
        "div",
        {
          staticClass: "product-item__gallery",
          on: {
            mouseover: function($event) {
              return _vm.onGalleryHovered(true)
            },
            mouseleave: function($event) {
              return _vm.onGalleryHovered(false)
            }
          }
        },
        [
          _c("ProductCardGallery", {
            attrs: {
              product: _vm.selectedProduct,
              "includes-aspect-ratio": _vm.includesAspectRatio,
              onPlp: _vm.onPlp,
              "image-hovered": _vm.galleryHovered
            },
            on: { focused: _vm.onGalleryFocus },
            scopedSlots: _vm._u(
              [
                {
                  key: "placeholderMedia",
                  fn: function() {
                    return [_vm._t("placeholderMedia")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.showQuickAdd
                ? _c("ProductQuickAdd", {
                    attrs: { onclick: _vm.toggleSwatches }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showProductSizes
                ? _c("ProductCardSizes", {
                    attrs: {
                      "context-url": _vm.selectedProduct.context_url,
                      sizes: _vm.productSizes.values,
                      "size-option-key": _vm.sizeOptionKey,
                      variants: _vm.selectedProduct.variants,
                      toggleSwatches: _vm.toggleSwatches,
                      product: _vm.selectedProduct
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ProductCardBadges", {
        key: _vm.badgeData.title,
        attrs: { product: _vm.badgeData }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-item__details-wrapper relative" },
        [
          _c("ProductCardDetails", {
            attrs: {
              onPlp: _vm.onPlp,
              product: _vm.selectedProduct,
              initialProduct: _vm.product,
              updateProduct: _vm.updateProduct
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "wishlist",
                  fn: function() {
                    return [_vm._t("wishlist")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }